const OSS = require('ali-oss')

export function client(data) {
  //后端提供数据
  // return new OSS({
  //     accessKeyId: data.accessKeyId,
  //     accessKeySecret: data.accessKeySecret,
  //     stsToken: data.securityToken,
  //     region: data.region, // oss地区
  //     bucket: data.bucket
  // })
  return new OSS({
        accessKeyId: data.accessid,
        stsToken: data.securityToken,
        accessKeySecret: '2xmp3CILTsn95GCZPOb8En91tV224k',
        bucket:'zhinenggui',
        region:'oss-cn-shanghai',
        success_action_status: '200', // 默认200
    })
}


